import { Form, Space, Typography, theme } from "antd";
import React, { useEffect, useState } from "react";
import Gcs from "./Gcs";
import "./PhysioGcs.css";
const PhysioGcs = ({ formData, form }) => {
  const { token } = theme.useToken();
  const [states, setStates] = useState({});
  const physioGcs = formData?.general_examination?.gcs || formData?.gcs;
  const handleChange = (key, val) => {
    setStates((prev) => ({
      ...prev,
      [key]: val,
    }));
  };
  const aggregate = Object.values(states).reduce((acc, cur) => acc + cur, 0);
  const getInterpretation = () => {
    const string =
      aggregate < 9
        ? "Severe Brain Injury"
        : aggregate < 13
        ? "Moderate Brain Injury"
        : aggregate < 15
        ? "Mild Brain Injury"
        : "Normal";
    form.setFieldValue(["gcs", "score"], aggregate);
    form.setFieldValue(["gcs", "interpretation"], string);
    return string;
  };
  const interpretation = getInterpretation();

  useEffect(() => {
    // setStates(formData?.general_examination?.gcs || {});
    const gcsStates = Object.fromEntries(
      Object.entries(physioGcs ?? {})?.filter((option) =>
        ["eye_opening_response", "motor_response", "verbal_response"]?.includes(
          option[0]
        )
      )
    );
    setStates(gcsStates);
  }, [formData]);
  return (
    <>
      <Form.Item name={["gcs", "score"]} hidden />
      <Form.Item name={["gcs", "interpretation"]} hidden />
      <Typography.Title level={5}>GCS</Typography.Title>
      <Space size="large" className="physio-gcs-score-row" wrap>
        <Typography.Text>Score:{aggregate}</Typography.Text>
        <Typography.Text>Interpretation: {interpretation}</Typography.Text>
        <Typography.Text>
          E{states?.eye_opening_response} V{states?.verbal_response} M
          {states?.motor_response}{" "}
        </Typography.Text>
      </Space>
      <div
        style={{
          "--gcs-color": token.colorPrimary,
        }}
      >
        <div
  className="physio-general-exam-gcs"
  style={{ "--gcs-color": token.colorPrimary }}
>
  <Gcs initial={true} handleChange={handleChange} />
</div>
      </div>
    </>
  );
};

export default PhysioGcs;
